import React, { useState } from 'react';

import Button, { BUTTON_SIZES, BUTTON_TYPES } from 'buyside/components/presentation/Button/button';

import { MakeCheckoutSessionUpdatePaymentMethodMutationFn } from 'interfaces/graphql-typings';

import { ENV_VARS, verifyEnvVar } from 'env/usage';

const makeOnClick = (
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>,
  makeCheckoutSessionUpdatePayment: MakeCheckoutSessionUpdatePaymentMethodMutationFn,
  redirectToCheckout: (
    options: stripe.StripeServerCheckoutOptions
  ) => Promise<stripe.StripeRedirectResponse>
): ((e: React.SyntheticEvent) => Promise<void>) => async (
  e: React.SyntheticEvent
): Promise<void> => {
  e.preventDefault();
  setIsLoading(true);

  const res = await makeCheckoutSessionUpdatePayment();

  setIsLoading(false);

  if (res?.data?.makeCheckoutSessionUpdatePaymentMethod) {
    redirectToCheckout({
      sessionId: res.data.makeCheckoutSessionUpdatePaymentMethod.sessionId
    });
  }
};

const UpdatePaymentBtn: React.FC<{
  makeCheckoutSessionUpdatePayment: MakeCheckoutSessionUpdatePaymentMethodMutationFn;
}> = ({ makeCheckoutSessionUpdatePayment }): React.ReactElement => {
  const [isLoading, setIsLoading] = useState(false);

  const { redirectToCheckout } = window.Stripe(verifyEnvVar(ENV_VARS.STRIPE_PUBLIC_KEY));

  return (
    <Button
      type={BUTTON_TYPES.PRIMARY}
      size={BUTTON_SIZES.MEDIUM}
      isLoading={isLoading}
      onClick={makeOnClick(setIsLoading, makeCheckoutSessionUpdatePayment, redirectToCheckout)}
      text="Update"
    />
  );
};

export default UpdatePaymentBtn;
